import { has } from 'lodash';
import { addToCart } from '../../useShopifyCart';

export default {
  name: "global",
  store() {
    return {
      isMobileMenuVisible: false,
      isMinicartVisible: false,
      isPredictiveSearchVisible: false,
      isWindowScrolled: false,
      cart: null,
      lastScrollY: 0,
      touchStartY: 0,
      init() {
        console.log("Arctheme Global Store Initialized.");
     
        setTimeout(() => {
          if (window.innerWidth < 1024 && window.scrollY === 0) {
            this.isPredictiveSearchVisible = true;
            setTimeout(() => {
                document.querySelector('.header').style.marginBottom = `42px`; // This is set to static since element is not yet rendered to DOM
            }, 100);
          }
        }, 100);

        if (!window.arcthemeGlobalScroll) {
          window.arcthemeGlobalScroll = {
            lastScrollY: 0,
          };
        }
        
        this.lastScrollY = window.arcthemeGlobalScroll.lastScrollY || 0;

        window.addEventListener(
          "close-header-search",
          this.closeHeaderSearch.bind(this),
        );

        window.addEventListener(
          "scroll",
          this.onWindowScrollHandler.bind(this),
        );
        window.addEventListener('touchstart', this.onTouchStartHandler.bind(this));
        window.addEventListener('touchmove', this.onTouchMoveHandler.bind(this));
        window.addEventListener("keydown", this.onKeyDownHandler.bind(this));
        window.addEventListener(
          "mobile-menu-open",
          this.openMobileMenu.bind(this),
        );
        window.addEventListener(
          "mobile-menu-closed",
          this.closeMobileMenu.bind(this),
        );

        this.initLiquidAJaxCart();

        this.updateHeaderHeight();

        window.addEventListener("scroll", this.updateHeaderHeight.bind(this));

        const observer = new MutationObserver(
          this.updateHeaderHeight.bind(this),
        );
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });

        Object.defineProperty(this, "isPredictiveSearchVisible", {
          get: () => this._isPredictiveSearchVisible,
          set: (value) => {
            this._isPredictiveSearchVisible = value;
            if (!value) {
              document.querySelector('.header').style.marginBottom = `0px`;
              document.body.classList.remove('overflow-hidden');
            }
          },
        });
      },
      get bodyClasses() {
        let classes = [];

        if (this.isMobileMenuVisible) {
          classes.push("mobile-menu-visible");
        }
        if (this.isMinicartVisible) {
          classes.push("minicart-open");
        }
        if (this.isPredictiveSearchVisible) {
          classes.push("search-open");
        }

        return classes.join(" ") || "";
      },
      openMobileMenu() {
        this.isMobileMenuVisible = true;
        document.body.classList.add("mobile-menu-visible");
      },
      closeMobileMenu() {
        this.isMobileMenuVisible = false;
        document.body.classList.remove("mobile-menu-visible");
      },
      toggleMobileMenu() {
        this.isMobileMenuVisible = !this.isMobileMenuVisible;
      },
      toggleMinicart() {
        this.isMinicartVisible = !this.isMinicartVisible;
        document.body.classList[this.isMinicartVisible ? "add" : "remove"](
          "no-scroll",
        );
      },
      toggleSearch() {
        this.isPredictiveSearchVisible = !this.isPredictiveSearchVisible;
        const searchInput = document.querySelector('[data-search-input]');
        const fakeInput = document.createElement('input');
        fakeInput.setAttribute('type', 'text');
        fakeInput.style.position = 'absolute';
        fakeInput.style.left = '0';
        fakeInput.style.top = '0';
        fakeInput.style.opacity = '0';
        fakeInput.style.height = '0';
        fakeInput.style.width = '0';
        fakeInput.style.pointerEvents = 'none';
        fakeInput.style.fontSize = '16px';
        if (searchInput && searchInput.parentNode) {
          searchInput.parentNode.insertBefore(fakeInput, searchInput.nextSibling);
        } else {
          document.body.appendChild(fakeInput);
        }

        fakeInput.focus();

        setTimeout(() => {
          if (searchInput) searchInput.focus();
          fakeInput.remove();
        }, 1000);


      },
      initLiquidAJaxCart() {
  
        document.addEventListener("liquid-ajax-cart:request-end", (event) => {
          const { requestState, cart } = event.detail;

          if (
            requestState.requestType === "add" &&
            requestState.responseData?.ok
          ) {
            this.isMinicartVisible = true;
          }

          this.cart = cart;
        });

        document.addEventListener("fetch-api-cart:request-end", (event) => {
          const { requestState, cart, showMiniCart = true } = event.detail;
          console.log('event-received', event);
          if (
            requestState.requestType === "fetch" &&
            requestState.responseData?.ok && showMiniCart 
          ) {
            this.isMinicartVisible = true;
          }

          this.cart = cart;
        });
      },



      
      onWindowScrollHandler() {
        const isScrolled = window.scrollY > 0;
        this.isWindowScrolled = isScrolled;
        if (window.innerWidth < 1024 && window.scrollY === 0) {
            this.isPredictiveSearchVisible = true;
            document.querySelector('.header').style.marginBottom = `42px`;
        }
        else {
           document.querySelector('.header').style.marginBottom = `0px`;
        }
        document.body.classList[isScrolled ? "add" : "remove"]("scrolled");
        this.updateHeaderHeight();
      },

      onTouchStartHandler(event) {
        if (event.touches && event.touches.length) {
          this.touchStartY = event.touches[0].clientY;
        }
      },

      onTouchMoveHandler(event) {
        const isMobile = window.innerWidth < 1024;
        if (!isMobile || !this.isPredictiveSearchVisible) return;
        if (event.touches && event.touches.length) {
          const touchMoveY = event.touches[0].clientY;
          const searchInput = document.querySelector('[data-search-input]');
          if (Math.abs(touchMoveY - this.touchStartY) > 50 && (!searchInput || !searchInput.value.trim())) {
            this.isPredictiveSearchVisible = false;
          }
        }
      },
      onKeyDownHandler(event) {
        if (event.key === "Escape") {
          this.isMinicartVisible = false;
          this.isPredictiveSearchVisible = false;
        }
      },
      updateHeaderHeight() {
        requestAnimationFrame(() => {
          const header = document.querySelector(".header");
          const promoBar = document.querySelector(".promobar");

          let headerHeight = header ? header.offsetHeight : 0;

          if (
            promoBar &&
            promoBar.style.display !== "none" &&
            window.scrollY === 0
          ) {
            headerHeight += promoBar.offsetHeight;
          }

          document.documentElement.style.setProperty(
            "--header-height",
            `${headerHeight}px`,
          );
        });
      },
      lockScrollPosition() {
        const scrollPosition = window.scrollY;
        document.documentElement.style.setProperty(
          "--scroll-position",
          `-${scrollPosition}px`,
        );
        document.body.style.top = `-${scrollPosition}px`;
      },
      unlockScrollPosition() {
        const scrollPosition = Math.abs(
          parseInt(document.body.style.top || "0", 10),
        );
        document.body.style.top = "";
        window.scrollTo(0, scrollPosition);
      },

      closeHeaderSearch() {
        this.isPredictiveSearchVisible = false;
      },
    };
  },
};
